import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPushPin$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPushPin extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0ca154e5f8201e702fcdbc7393c6ae775df09cc1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'be72d27d607baef95a6ce914b336f5a73591ac75', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6d11d231f1fdd608d200edbe770e0f85852911ef', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.825 4.031A2.79 2.79 0 0 1 8.333 2.5h5.336a2.79 2.79 0 0 1-2.493 1.531zM6.532 1.238c0-.131.107-.238.239-.238h8.46c.131 0 .238.107.238.238a4.29 4.29 0 0 1-1.969 3.61v4.416A4 4 0 0 1 16.068 13v.957a.5.5 0 0 1-.5.5H12V21l-2-1.773v-4.77H6.432a.5.5 0 0 1-.5-.5V13A4 4 0 0 1 8.5 9.263V4.848a4.29 4.29 0 0 1-1.969-3.61M12 5.452V9h-1.999V5.452q.4.079.824.08h.351q.424-.001.824-.08m2.568 7.506a2.5 2.5 0 0 0-2.5-2.458H9.932a2.5 2.5 0 0 0-2.5 2.457z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-push-pin", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-push-pin"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-push-pin":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPushPin$1);
            }
            break;
    } });
}

const CosmosIconPushPin = CosmosIconPushPin$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPushPin, defineCustomElement };
